export default __webpack_public_path__ + "static/media/logoLine.d4642d39.webp";